import React from "react";
import { Header, Footer } from "../LandingPage/LandingPage";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-grow container mx-auto px-4 py-12 max-w-4xl text-gray-800">
        <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>

        <p className="mb-4">
          At Gradiance, we are committed to protecting your privacy. This policy
          outlines how we collect, use, and protect the information you provide
          to us when you visit our website or interact with us.
        </p>

        <h2 className="text-xl font-semibold mb-2">Information We Collect</h2>
        <ul className="list-disc list-inside mb-4 text-sm">
          <li>Contact details (e.g., name, phone number, email)</li>
          <li>Non-personal information such as IP address, browser type, etc.</li>
        </ul>

        <h2 className="text-xl font-semibold mb-2">How We Use Your Information</h2>
        <ul className="list-disc list-inside mb-4 text-sm">
          <li>To respond to queries or requests</li>
          <li>To improve website performance and customer experience</li>
          <li>To send updates (if opted in)</li>
        </ul>

        <h2 className="text-xl font-semibold mb-2">Third-Party Sharing</h2>
        <p className="mb-4 text-sm">
          We do not sell or rent your personal data. We may share it with
          trusted service providers for operational purposes.
        </p>

        <h2 className="text-xl font-semibold mb-2">Data Security</h2>
        <p className="mb-4 text-sm">
          We implement appropriate security measures, but no method is 100%
          secure.
        </p>

        <h2 className="text-xl font-semibold mb-2">Your Consent</h2>
        <p className="mb-4 text-sm">
          By using our site, you consent to our privacy policy.
        </p>

        <p className="text-sm text-gray-600">
          Questions? Email us at{' '}
          <a
            href="mailto:gradiance.in@gmail.com"
            className="underline text-orange-600"
          >
            gradiance.in@gmail.com
          </a>
        </p>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;